var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfessional04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4169 40.5L33.4706 27M20.6134 27L5.66707 40.5M4.54199 15.75L22.9131 28.6097C24.4007 29.6511 25.1445 30.1718 25.9536 30.3734C26.6683 30.5516 27.4157 30.5516 28.1304 30.3734C28.9395 30.1718 29.6833 29.6511 31.1709 28.6098L49.542 15.75M15.342 45H38.742C42.5223 45 44.4125 45 45.8564 44.2643C47.1265 43.6171 48.1591 42.5845 48.8063 41.3144C49.542 39.8705 49.542 37.9804 49.542 34.2V19.8C49.542 16.0196 49.542 14.1295 48.8063 12.6856C48.1591 11.4155 47.1265 10.3829 45.8564 9.73571C44.4125 9 42.5223 9 38.742 9H15.342C11.5616 9 9.67146 9 8.22756 9.73571C6.95746 10.3829 5.92484 11.4155 5.2777 12.6856C4.54199 14.1295 4.54199 16.0196 4.54199 19.8V34.2C4.54199 37.9804 4.54199 39.8705 5.2777 41.3144C5.92484 42.5845 6.95746 43.6171 8.22756 44.2643C9.67146 45 11.5616 45 15.342 45Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessional04);
export default __webpack_public_path__ + "static/media/professional04.6d5dba6566a001144ef4283dd7483c4d.svg";
export { ForwardRef as ReactComponent };